// Learning Center (LMS) progress data — ported verbatim from hec-composable
// (`overrides/app/hooks/use-learning-center.ts`). Persisted as a JSON string on
// the SCAPI customer Profile attribute `c_learningCenterData` (SFCC-11502 /
// ARTICLES-11). Lesson IDs are hierarchical: `goalID--levelID--lessonID`.

export type QuizAttempt = {
  pass: 0 | 1; // 0 = fail, 1 = pass
  time: string; // ISO date
};

export type Quiz = {
  id: string;
  complete?: string; // ISO date
  attempts?: QuizAttempt[];
};

export type Lesson = {
  id: string;
  complete?: string; // ISO date
};

export type Module = {
  id: string;
  start?: string; // ISO date
  complete?: string; // ISO date
  lessons?: Lesson[];
  quiz?: Quiz;
};

export type Level = {
  id: string;
  start?: string; // ISO date
  complete?: string; // ISO date
  modules: Module[];
};

export type Goal = {
  id: string;
  open?: string; // ISO date
  start?: string; // ISO date
  complete?: string; // ISO date
  levels: Level[];
};

export type LearningCenterData = {
  goals: Goal[];
  activeGoal: string; // active goal ID
  tpaLearningCenterConsentData: boolean | null;
  activeLessonUrl?: string;
  /** Guest-only sentinel: set true after a one-shot merge into the profile. */
  hasRegistered?: boolean;
} | null;

export type UpdatedDataResponse = {
  success: boolean;
  data?: string;
  errorMsg?: string;
  errorDetail?: unknown;
};

/** Empty initial shape — matches composable's `{goals: []}` seed. */
export const EMPTY_LEARNING_CENTER_DATA: NonNullable<LearningCenterData> = {
  goals: [],
  activeGoal: "",
  tpaLearningCenterConsentData: null,
};
